import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Form,
    Alert,
    Spinner
} from 'reactstrap';

import {useSelector, useDispatch} from "react-redux";

import {Link} from "react-router-dom";
import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik} from "formik";
import {
    contactMoreInformation,
    contactResearchAssistant,
    deviceRegister, recordActivity
} from '../slices/register'
import useCheckMobileScreen from "../common/useCheckMobileScreen";

const Landing = (props) => {
    const dispatch = useDispatch();
    const [screen, setScreen] = useState(1)
    const {error, loading} = useSelector(state => ({
        ...state
    }));


    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {},
        validationSchema: Yup.object().shape({
            contact_me: Yup.bool().oneOf([true, false], "Your answer is required"),
        }),
        onSubmit: (values) => {
            let deviceId = sessionStorage.getItem('device') || undefined
            dispatch(contactMoreInformation(deviceId, values, () => {
                props.router.navigate('/enrollment-type')
            }))
        }
    });

    useEffect(() => {
        let deviceId = sessionStorage.getItem('device') || undefined
        dispatch(recordActivity(deviceId, {
            action: "survey",
            page_id: "0-3"
        }))
    }, [dispatch, sessionStorage, recordActivity])

    const scrollStep = () => {
        setTimeout(() => {
            if (window.document.getElementById('scrollItem')) {
                window.document.getElementById('scrollItem').scrollTo({top: 0, behavior: "smooth"})
                window.document.getElementById('scrollItem').scroll({top: 0, behavior: "smooth"})
            }
        }, 100)
    }
    document.title = "Study Information";
    return (
        <React.Fragment>
            <div>
                <Container>
                    <Row className="pt-5  justify-content-center">
                        <Col className="p-0" xl={8} md={10} sm={12}>
                            <div className="text-center mt-2">
                                <h3>Telehealth for Problems with Opioid Use</h3>
                            </div>
                            <Card className="p-2 mt-4">
                                <CardBody className="p-4" id="scrollItem">
                                    {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                        action="#">
                                        <Row className="justify-content-center">
                                            <Col className="pr-5 pl-5" xl={10} md={10} sm={12}>
                                                <>
                                                    <h5>What is personally identifiable information?</h5>
                                                    <br/>
                                                    <ul>
                                                        <li>
                                                            <p>Personal information including your name, date of birth,
                                                                phone
                                                                numbers, and postal and email addresses.</p>
                                                        </li>
                                                    </ul>

                                                    <br/>

                                                    <h5>What are my rights pertaining to my personal information?</h5>
                                                    <br/>
                                                    <ul>
                                                        <li><p>
                                                            You have the right to decide at any time that you do not
                                                            want to
                                                            answer these eligibility questions or participate in the
                                                            study, if you
                                                            qualify.
                                                        </p></li>
                                                        <li><p>You have the right to request access to the information that
                                                            we will
                                                            collect.
                                                        </p></li>
                                                        <li><p>You have the right to object if you believe your information
                                                            has not
                                                            been handled properly.
                                                        </p></li>
                                                    </ul>

                                                    <br/>

                                                    <h5>What will happen to my personal/health information?</h5>
                                                    <br/>
                                                    <ul>
                                                        <li><p>Your information will be used to determine your eligibility for this study.</p></li>
                                                        <li><p>
                                                            The information will be kept confidential in a secure
                                                            database.
                                                        </p></li>
                                                        <li><p>If you are not eligible, we will keep your non
                                                            identifiable
                                                            information
                                                            and use it when we examine and report on everyone’s results
                                                            together.
                                                        </p></li>
                                                    </ul>
                                                    <br/>

                                                    {/*<h5>Would you like to be contacted about future projects?</h5>*/}
                                                </>
                                                {/*<>*/}
                                                {/*    <div className="mt-4">*/}
                                                {/*        <Button aria-label={"yes contact"}*/}
                                                {/*                disabled={error ? null : loading ? true : false}*/}
                                                {/*                className={"btn w-100 " + (validation.values.contact_me == true ? "button-primary" : "button-secondary")}*/}
                                                {/*                onClick={() => {*/}
                                                {/*                    validation.setFieldValue("contact_me", true)*/}
                                                {/*                }}>*/}
                                                {/*            {loading ? <Spinner size="sm"*/}
                                                {/*                                className='me-2'> Loading... </Spinner> : null}*/}
                                                {/*            Yes*/}
                                                {/*        </Button>*/}
                                                {/*    </div>*/}
                                                {/*    <div className="mt-4">*/}
                                                {/*        <Button aria-label={"no contact"}*/}
                                                {/*                disabled={error ? null : loading ? true : false}*/}
                                                {/*                className={"btn w-100 " + (validation.values.contact_me == false ? "button-primary" : "button-secondary")}*/}
                                                {/*                onClick={() => {*/}
                                                {/*                    validation.setFieldValue("contact_me", false)*/}
                                                {/*                }}>*/}
                                                {/*            {loading ? <Spinner size="sm"*/}
                                                {/*                                className='me-2'> Loading... </Spinner> : null}*/}
                                                {/*            No*/}
                                                {/*        </Button>*/}
                                                {/*    </div>*/}
                                                {/*</>*/}
                                            </Col>
                                            <Col className="pr-5 pl-5" xl={10} md={10} sm={12}>
                                                <div className="mt-4">
                                                    <Button aria-label={"previous"}
                                                            disabled={error ? null : loading ? true : false}
                                                            className="btn button-secondary" type="button"
                                                            onClick={() => {
                                                                props.router.navigate('/study-information')
                                                            }}>
                                                        Prev
                                                    </Button>
                                                    <Button aria-label={"next"}
                                                            disabled={error ? null : loading ? true : false}
                                                            className="btn button-primary pull-right" type="submit">
                                                        Next
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                    <br/>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
        ;
};

export default withRouter(Landing);
